import { render, staticRenderFns } from "./BulkTransactionForm.vue?vue&type=template&id=36cddc96&"
import script from "./BulkTransactionForm.vue?vue&type=script&lang=js&"
export * from "./BulkTransactionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports